const renderPaginationStyle = (index, theme, paginationColor) => {
  const styleArr = [
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 24px;
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      background: #ddd;
      cursor: pointer;
      &:first-of-type {
        border-radius: 999px 0 0 999px;
      };
      &:last-of-type {
        border-radius: 0 999px 999px 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      position: relative;
      &:after {
        content: "";
        border-radius: 999px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${paginationColor};
      }
    }`,
    `.swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 100%;
      background: #ddd;
      margin: 0 4px;
      cursor: pointer;
    }
    .swiper-pagination-bullet-active {
      background: ${paginationColor};
      border-radius: ${theme.borderRadius.l};
      width: 12px;
      height: 12px;
      border-radius: 50%;
      transform: translateY(2px);
    }`
  ];
  return index > 0 ? styleArr[index - 1] : "";
};
const renderSwipeButton = (index) => {
  const styleArr = [
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-top-left-radius: 100px;
      border-bottom-left-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background-color: rgba(168, 168, 168, 0.46);
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-right: 0.5rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      border-radius: 50%;
      background-color: rgba(168, 168, 168, 0.46);
      margin-left: 1rem;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`,
    `.swiper-button-next {
      right: 0;
      left: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }
    .swiper-button-prev {
      left: 0;
      right: auto;
      background-color: transparent;
      &:after {
        mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
        content: ' ';
        height: 30px;
        width: 30px;
        mask-size: contain;
        display: inline-block;
        background: #333;
      }
    }`
  ];
  return index > 0 ? styleArr[index - 1] : null;
};

export { renderPaginationStyle, renderSwipeButton };
